module.exports = __webpack_public_path__ + "img/10-2.b5f61b18.jpg";